module.exports = __webpack_public_path__ + "img/SprayPainting.f8e129f0.jpg";